{
  "version": 1,
  "asset_id": "9e9b9bc1-9b21-485e-b710-5b1e9bed68c7",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/9e9b9bc1-9b21-485e-b710-5b1e9bed68c7/td03-eternal-ascent.png",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/9e9b9bc1-9b21-485e-b710-5b1e9bed68c7/td03-eternal-ascent.png",
  "original_filename": "td03-eternal-ascent.png",
  "size": 989553,
  "content_type": "image/png",
  "created_at": "2026-09-06T13:31:01Z"
}
